import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { API } from "../context/AuthContext";

export default function Unsubscribe() {
  const [sp] = useSearchParams(); const t = sp.get("t") || "";
  const [state, setState] = useState({ status: "loading" });
  useEffect(() => { if (!t) { setState({ status: "invalid" }); return; }
    axios.get(`${API}/email/unsubscribe`, { params: { t } }).then(r => setState({ status: "ok", email: r.data.email })).catch(() => setState({ status: "invalid" })); }, [t]);
  return (
    <div className="min-h-screen grain-bg"><Navbar />
      <div className="pt-32 pb-24 max-w-md mx-auto px-5 text-center" data-testid="unsubscribe-page">
        <img src="/logo-mark.png" alt="Rally Love" className="w-16 mx-auto mb-6 opacity-80" />
        {state.status === "loading" && <p className="text-slate-400">Un istante…</p>}
        {state.status === "ok" && <><div className="pill-badge inline-flex mb-4">DISISCRIZIONE COMPLETATA</div>
          <h1 className="font-display font-black text-3xl mb-3">Non riceverai più email commerciali</h1>
          <p className="text-slate-400 text-sm mb-8" data-testid="unsubscribe-ok">Il consenso marketing per <b>{state.email}</b> è stato revocato. Continuerai a ricevere solo le comunicazioni indispensabili (sicurezza, acquisti, licenze).</p></>}
        {state.status === "invalid" && <><div className="pill-badge inline-flex mb-4">LINK NON VALIDO</div>
          <h1 className="font-display font-black text-3xl mb-3">Non è stato possibile completare l'operazione</h1>
          <p className="text-slate-400 text-sm mb-8" data-testid="unsubscribe-invalid">Il link non è valido. Puoi gestire le tue preferenze dal profilo oppure contattare l'assistenza Rally Love.</p></>}
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/settings/notifications" className="btn-crimson" data-testid="unsubscribe-prefs">GESTISCI PREFERENZE</Link>
          <Link to="/" className="btn-outline-rl">HOME</Link>
        </div>
      </div>
    </div>
  );
}
